import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-processando-assinatura',
  templateUrl: './processando-assinatura.component.html',
  styleUrl: './processando-assinatura.component.scss'
})
export class ProcessandoAssinaturaComponent implements OnInit {
  breadCrumbItems!: Array<{}>;
  
  ngOnInit(): void {

    this.breadCrumbItems = [
      { label: "Documentos" },
      { label: "Contrato", active: true },
    ];
  }
}
